import { defineAsyncComponent } from 'vue'

export const GovernmentNewsRoutes = [
  {
    path: '/government-news',
    name: 'List',
    component: defineAsyncComponent(() => import('./views/List.vue')),
    meta: {
      auth: true,
      layout: 'home'
      // permission: 'government-news:list'
    }
  },
  {
    path: '/government-news/configure',
    name: 'Configure',
    component: defineAsyncComponent(() => import('./views/Configure.vue')),
    meta: {
      auth: true,
      layout: 'home'
      // permission: 'government-news:configure'
    }
  }
]
